module.exports = __webpack_public_path__ + "static/media/bubbles-bottom.2f58f8ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/biocodex-um/bubbles-bottom.png
// module id = 645
// module chunks = 1